import * as React from 'react'

import { X } from 'lucide-react'
import { observer } from 'mobx-react'

import { ITileset } from '~/client/graph'
import { Button } from '~/client/src/shared/components/Button/Button'
import TilesetNotificationCard from '~/client/src/shared/components/MapBoxViewer/components/TilesetNotificationCard'
import TilesetUploadCard from '~/client/src/shared/components/MapBoxViewer/components/TilesetUploadCard'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import TilesetUploadProgressStore from '~/client/src/shared/stores/domain/TilesetUploadProgress.store'

const fileHistory = 'File History'

interface IProps {
  tilesetUploadProgressStore: TilesetUploadProgressStore
  tilesetsForNotifications: ITileset[]
  onClose: () => void
  onHideNotification: (tilesetId: string) => void
}

@observer
export default class MapNotificationsPopoverContent extends React.Component<IProps> {
  public render(): JSX.Element {
    const {
      tilesetUploadProgressStore,
      tilesetsForNotifications,
      onClose,
      onHideNotification,
    } = this.props
    const activeUploads = tilesetUploadProgressStore?.activeUploads || []
    const failedUploads = tilesetUploadProgressStore?.failedUploads || []

    return (
      <div className="tw:w-[300px] tw:max-h-[360px] tw:overflow-hidden tw:rounded-lg tw:border tw:border-solid tw:border-border tw:bg-popover tw:text-popover-foreground tw:shadow-md">
        <div className="tw:flex tw:items-center tw:border-0 tw:border-b tw:border-solid tw:border-border tw:p-3">
          <div className="tw:flex-1 tw:text-title-md tw:font-semibold tw:text-foreground">
            {fileHistory}
          </div>
          <Button
            variant="ghost"
            size="icon-sm"
            aria-label={Localization.translator.close}
            onClick={onClose}
          >
            <X />
          </Button>
        </div>
        <div className="tw:h-[300px] tw:overflow-x-hidden tw:overflow-y-auto">
          {activeUploads.map(upload => (
            <TilesetUploadCard
              key={upload.id}
              upload={upload}
              onCancel={() =>
                tilesetUploadProgressStore.cancelUpload(upload.id)
              }
            />
          ))}
          {failedUploads.map(upload => (
            <TilesetUploadCard
              key={upload.id}
              upload={upload}
              onCancel={() =>
                tilesetUploadProgressStore.removeUpload(upload.id)
              }
            />
          ))}
          {tilesetsForNotifications.map(i => (
            <TilesetNotificationCard
              tileset={i}
              key={i.id}
              onHide={() => onHideNotification(i.id)}
            />
          ))}
        </div>
      </div>
    )
  }
}
